import React from "react";
import withLanguageContext from "lib/hocs/withLanguageContext";
import * as CONSTANTS from "../../constants";
import PageToolbar from "./PageToolbar";
import TabToolbar from "./TabToolbar";
import MobileToolbar from "./MobileToolbar";
import { useMyLearning } from "../../context";
import FilterProvider, { useFilter } from "./context";

const mobileViewport = window.matchMedia("(max-width: 600px)").matches || false;

const FilterContent = ({ mode, languageContext }) => {
  const { searching } = useMyLearning();

  return (
    <div>
      {mode === CONSTANTS.MODE_FULL ? (
        mobileViewport ? (
          <MobileToolbar languageContext={languageContext} />
        ) : (
          <PageToolbar languageContext={languageContext} />
        )
      ) : (
        !searching && <TabToolbar languageContext={languageContext} />
      )}
    </div>
  );
};

const Filter = (props) => {
  // If a FilterProvider is already present higher in the tree, avoid wrapping again
  try {
    const filterCtx = useFilter();
    if (filterCtx) {
      return <FilterContent {...props} />;
    }
  } catch (error) {
    // No FilterProvider exists, so we need to create one
  }
  return (
    <FilterProvider mode={props.mode}>
      <FilterContent {...props} />
    </FilterProvider>
  );
};

export default withLanguageContext(Filter, "ActivityCentre");
